export { default } from './TermDictionaries';
